import { fetchWithAuth } from './fetchWithAuth';
const BASE_URL = process.env.REACT_APP_BASE_URL || '';

export async function addLike(userId, itemId) {
  const payload = { user_id: Number(userId), item_id: Number(itemId) };
  const res = await fetchWithAuth(`${BASE_URL}/api/likes`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });

  const text = await res.text();
  const contentType = res.headers.get('content-type') || '';
  const body = contentType.includes('application/json') && text ? JSON.parse(text) : text;

  if (!res.ok) {
    const err = new Error((body && body.message) || text || `HTTP ${res.status}`);
    err.status = res.status;
    err.body = body;
    throw err;
  }

  return body;
}

export async function deleteLike(userId, itemId) {
  const payload = { user_id: Number(userId), item_id: Number(itemId) };
  const res = await fetchWithAuth('/api/likes', {
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });

  const text = await res.text();
  const contentType = res.headers.get('content-type') || '';
  const body = contentType.includes('application/json') && text ? JSON.parse(text) : text;

  if (!res.ok) {
    const err = new Error((body && body.message) || text || `HTTP ${res.status}`);
    err.status = res.status;
    err.body = body;
    throw err;
  }

  return body;
}

export async function getLikes(userId) {
  // GET /api/likes should return liked products for the authenticated user.
  const path = `/api/likes/${Number(userId)}`;
  const res = await fetchWithAuth(path, { method: 'GET' });

  const text = await res.text();
  const contentType = res.headers.get('content-type') || '';
  const body = contentType.includes('application/json') && text ? JSON.parse(text) : text;

  if (!res.ok) {
    const err = new Error((body && body.message) || text || `HTTP ${res.status}`);
    err.status = res.status;
    err.body = body;
    throw err;
  }

  return body;
}

export default { addLike, deleteLike, getLikes };
